import { EyeOutlined } from "@ant-design/icons";
import { Modal, Spin, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import CaseLogsSummaryCountModal from "./CaseLogsSummaryCountModal";
import AuditTrailSummaryCountModal from "./AuditTrailSummaryCountModal";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  scheme: string;
  countModalData: any[];
  isLoading: boolean;
  selectedTile: any;
  countModalTotal: number;
  getPortalDetails: any;
}

const SummaryCountModal: React.FC<Props> = ({
  open,
  onClose,
  title,
  scheme,
  countModalData,
  isLoading,
  selectedTile,
  countModalTotal,
  getPortalDetails,
}) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
  });
  const [openCaseLogModal, setOpenCaseLogModal] = useState<boolean>(false);
  const [caseLogs, setCaseLogs] = useState<any>([]);
  const [openAuditModal, setOpenAuditModal] = useState<boolean>(false);
  const [auditTrails, setAuditTrails] = useState<any>([]);

  useEffect(() => {
    if (!open) {
      setPagination({
        current: 1,
        pageSize: 100,
      });
    }
  }, [open]);

  const renderValue = (value: any) =>
    value === null || value === undefined || value === "" ? "-" : value;

  const cghsNewColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration id",
      dataIndex: "registrationId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration date",
      dataIndex: "registrationDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status Name",
      dataIndex: "statusName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    ...(selectedTile?.type === "PREAUTH_QUERY" ||
    selectedTile?.type === "CLAIM_QUERY"
      ? [
          {
            title: "Logs",
            dataIndex: "caseLogs",
            align: "center" as const,
            render: (_: any, record: any) => {
              return (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <EyeOutlined
                    style={{
                      fontSize: 18,
                      color: "rgb(0, 84, 157)",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenCaseLogModal(true);
                      setCaseLogs(record?.caseLogs);
                    }}
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const cghsNewClaimDataExportColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Registration id",
      dataIndex: "registrationId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration date",
      dataIndex: "registrationDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim Initiated Amount",
      dataIndex: "claimInitiatedAmount",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Program ID",
      dataIndex: "programId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status Name",
      dataIndex: "statusName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const ayushmanBharatColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration id",
      dataIndex: "registrationId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration date",
      dataIndex: "registrationDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status Name",
      dataIndex: "statusName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    ...(selectedTile?.type === "PREAUTH_QUERY" ||
    selectedTile?.type === "CLAIM_QUERY"
      ? [
          {
            title: "Logs",
            dataIndex: "caseLogs",
            align: "center" as const,
            render: (_: any, record: any) => {
              return (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <EyeOutlined
                    style={{
                      fontSize: 18,
                      color: "rgb(0, 84, 157)",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenCaseLogModal(true);
                      setCaseLogs(record?.caseLogs);
                    }}
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const ayushmanBharatClaimDataExportColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Registration id",
      dataIndex: "registrationId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Registration date",
      dataIndex: "registrationDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim Initiated Amount",
      dataIndex: "claimInitiatedAmount",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Program ID",
      dataIndex: "programId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Status Name",
      dataIndex: "statusName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const portalSettlementColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Claim id",
      dataIndex: "claimId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Accept Date",
      dataIndex: "acceptDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Amount Credited",
      dataIndex: "amountCredited",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "BPA Fees",
      dataIndex: "bpaFees",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim Amount",
      dataIndex: "claimAmount",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Settlement Date",
      dataIndex: "settlementDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Settlement id",
      dataIndex: "settlementId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "TDS Amount",
      dataIndex: "tdsAmount",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const portalQueryColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Patient Name",
      dataIndex: "patientName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim id",
      dataIndex: "claimId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Card Id",
      dataIndex: "cardId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim Amount",
      dataIndex: "claimAmount",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Latest User Remarks",
      dataIndex: "latestUserRemarks",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: (
        <Tooltip title="Audit Trails">
          <span>A. T.</span>
        </Tooltip>
      ),
      dataIndex: "auditTrails",
      key: "auditTrails",
      width: 60,
      render: (_: any, record: any) => {
        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <EyeOutlined
              style={{
                fontSize: 18,
                color: "rgb(0, 84, 157)",
                cursor: "pointer",
              }}
              onClick={() => {
                setOpenAuditModal(true);
                setAuditTrails(record?.auditTrails);
              }}
            />
          </div>
        );
      },
    },
  ];

  const claimPendingColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Patient Name",
      dataIndex: "patientName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim id",
      dataIndex: "claimId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Card Id",
      dataIndex: "cardId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Admit No.",
      dataIndex: "admitNo",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Submitted On",
      dataIndex: "submittedOn",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const pendingIntimationColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Patient Name",
      dataIndex: "patientName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim id",
      dataIndex: "claimId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Card Id",
      dataIndex: "cardId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Admit No.",
      dataIndex: "admitNo",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Admit Date",
      dataIndex: "admitDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Intimation On",
      dataIndex: "intimationOn",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const echsClaimDataExportColumns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      render: (_: any, __: any, index: number) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
    },
    {
      title: "Patient Name",
      dataIndex: "patientName",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Claim id",
      dataIndex: "claimId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Card Id",
      dataIndex: "cardId",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Credit Number",
      dataIndex: "creditNumber",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Patient Type",
      dataIndex: "patientType",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Accept Date",
      dataIndex: "acceptDate",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Net Claim Amount",
      dataIndex: "netClaimAmt",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Approved Amount",
      dataIndex: "approvedAmt",
      render: renderValue,
      align: "center" as const,
    },
    {
      title: "Processed On",
      dataIndex: "processedOn",
      render: renderValue,
      align: "center" as const,
    },
  ];

  const echsColumnsConfig: any = {
    ECHS_SETTLEMENT: portalSettlementColumns,
    ECHS_QUERY: portalQueryColumns,
    ECHS_CLAIM_PENDING: claimPendingColumns,
    ECHS_PENDING_INTIMATION: pendingIntimationColumns,
    ECHS_CLAIM_DATA_EXPORT: echsClaimDataExportColumns,
  };

  const getColumnsBySchemeName = () => {
    if (scheme?.trim().toUpperCase()?.includes('CGHS')) {
      if (selectedTile?.type === 'CLAIM_DATA_EXPORT') {
        return cghsNewClaimDataExportColumns;
      } else {
        return cghsNewColumns;
      }
    } else if (scheme?.trim().toUpperCase() === 'ECHS') {
      return echsColumnsConfig[selectedTile?.type];
    } else if (scheme?.trim().toUpperCase() === 'AYUSHMAN BHARAT') {
      if (selectedTile?.type === 'CLAIM_DATA_EXPORT') {
        return ayushmanBharatClaimDataExportColumns;
      } else {
        return ayushmanBharatColumns;
      }
    } else {
      return [];
    }
  }

  const columns = getColumnsBySchemeName();

  // const columns =
  //   scheme?.trim().toUpperCase() === "CGHS NEW"
  //     ? selectedTile?.type === "CLAIM_DATA_EXPORT"
  //       ? cghsNewClaimDataExportColumns
  //       : cghsNewColumns
  //     : echsColumnsConfig[selectedTile?.type];

  const SCALE = 0.67;

  const [scrollY, setScrollY] = useState(window.innerHeight / SCALE - 210);

  useEffect(() => {
    const handleResize = () => {
      setScrollY(window.innerHeight / SCALE - 210);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Modal
      open={open}
      footer={null}
      width="100vw"
      onCancel={onClose}
      wrapClassName="management-age-stage-table-modal"
      style={{
        top: 10,
        left: 4,
        padding: 0,
        maxWidth: "100vw",
        height: "145vh",
      }}
      title={
        <>
          {title}
          <span style={{ color: "#1d4ed8", marginLeft: 8 }}>
            ({countModalTotal || 0})
          </span>
        </>
      }
      bodyStyle={{
        height: "calc(144vh - 55px)",
        overflow: "auto",
        padding: 0,
      }}
    >
      <div className="operational-table-modal">
        <Spin spinning={isLoading}>
          <Table
            dataSource={countModalData}
            columns={columns}
            rowKey={(record, index) => `${index}-${pagination.current}`}
            className="operational-dashboard-table"
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: countModalTotal,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              onChange: (page, pageSize) => {
                setPagination({ current: page, pageSize });
                getPortalDetails(
                  selectedTile.type,
                  selectedTile.id,
                  page || 1,
                  pageSize || 100,
                );
              },
            }}
            scroll={{ x: 900, y: scrollY }}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "ant-table-row-light" : ""
            }
            style={{
              borderRadius: 16,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              background: "#fff",
            }}
          />
        </Spin>
      </div>

      <CaseLogsSummaryCountModal
        open={openCaseLogModal}
        onClose={() => setOpenCaseLogModal(false)}
        caseLogs={caseLogs}
      />

      <AuditTrailSummaryCountModal
        open={openAuditModal}
        onClose={() => setOpenAuditModal(false)}
        auditTrails={auditTrails}
      />
    </Modal>
  );
};

export default SummaryCountModal;
